import React, { useState, useEffect, useCallback, useRef } from "react";
import {
    Layout,
    Button,
    Row,
    Form,
    Input,
    Col,
    Select,
    Collapse,
    Modal,
    notification,
    Tag,
    Typography,
    Tabs,
} from "antd";
import { useNavigate } from "react-router-dom";
import TopHeader from "../../common/TopHeader/TopHeader";
import Sidebar from "../../common/Sidebar/Sidebar";
import UserApi from "../../common/Apis/UserApi";
// import FooterDashboard from "../../common/FooterDashboard/FooterDashboard";
import {
    MinusCircleTwoTone,
    PlusCircleTwoTone,
} from "@ant-design/icons";
import QuestionnairesApi from "../../common/Apis/QuestionnairesApi";
import { Content } from "antd/es/layout/layout";
import TabPane from "antd/es/tabs/TabPane";

const { confirm } = Modal;
const { Text } = Typography;

const UserLogs = () => {
    const [isLoading, setIsLoading] = useState(false);

    return (
        <Layout style={{ minHeight: "100vh" }}>
            <Sidebar />
            <Layout>
                <TopHeader />
                {isLoading && <div className="spinner-overlay"><div className="spinner"></div></div>}

                {/* Filter Section */}
                {/* <div style={{ padding: "20px", paddingBottom: "5px" }}>
                    <Form name="filterForm" layout="vertical" className="FilterForm" onFinish={handleSubmit}>
                        <Collapse>
                            <Panel header={<h5 className="mb-0"><b>Filter</b></h5>} key="1">
                                {filterUser.map((input, index) => (
                                    <Row key={index} gutter={12}>
                                        <Col span={5}>
                                            <Form.Item rules={[{ required: true, message: "Please Select" }]}>
                                                <Select placeholder="Filter By" value={input.title} onChange={(value) => handleChangeTitle(index, value)} options={[{ value: "firstName", label: "Name" }, { value: "email", label: "Email" }]} />
                                            </Form.Item>
                                        </Col>
                                        <Col span={4}>
                                            <Form.Item rules={[{ required: true, message: "Please Select type." }]}>
                                                <Select placeholder="Condition" value={input.answerType} onChange={(value) => handleChangeAnswertype(index, value)} options={[{ value: "%", label: "Matches with" }, { value: "=", label: "Equals to" }]} />
                                            </Form.Item>
                                        </Col>
                                        <Col span={5}>
                                            <Form.Item rules={[{ required: true, message: "Please enter Text." }]}>
                                                <Input value={input.name} onChange={(e) => handleChangename(index, e.target.value)} placeholder="Text" />
                                            </Form.Item>
                                        </Col>
                                        <Col span={8}>
                                            {index === 0 ? (
                                                <Row gutter={23} className="mb-3">
                                                    <Col span={2}><PlusCircleTwoTone onClick={handleAddfilterUser} /></Col>
                                                    <Col span={10}><Button type="primary" htmlType="submit">Filter</Button></Col>
                                                    <Col span={10}><Button type="default" htmlType="reset" onClick={handleClear}>Clear</Button></Col>
                                                </Row>
                                            ) : <MinusCircleTwoTone onClick={() => handleRemovefilterUser(index)} />}
                                        </Col>
                                    </Row>
                                ))}
                            </Panel>
                        </Collapse>
                    </Form>
                </div> */}

                {/* Users Table */}
                <Content className="form-content nav-content" style={{ margin: "14px 16px 0", padding: "30px", background: "white" }}>
                     <Tabs defaultActiveKey="1">
          <TabPane tab="Product" key="1">
            <table className="table Tenants-table">
                        <thead>
                            <tr>
                                <th>Full Name</th>
                                <th className="text-center">Email</th>
                                <th className="text-center">Status</th>
                                <th className="text-center">Role</th>
                                <th>Registered Date</th>
                                <th></th>
                            </tr>
                        </thead>
                        {/* <tbody>{renderTableRows()}</tbody> */}
                    </table>
          </TabPane>
          <TabPane tab="Details" key="2">
            <p>Content of Details</p>
          </TabPane>
          <TabPane tab="Settings" key="3">
            <p>Content of Settings</p>
          </TabPane>
        </Tabs>
                </Content>
                {/* <FooterDashboard /> */}
            </Layout>
        </Layout>
    );
};

export default UserLogs;
